import moment from 'moment-timezone';
import { GlobalVariables } from '@/libs/core/global';

// Timezone pro zobrazování - vždy Praha bez ohledu na TZ prohlížeče
const DISPLAY_TIMEZONE = 'Europe/Prague';

export function formatDate(input: string) {
    if (!input) {
        return '';
    }

    return moment.tz(input, DISPLAY_TIMEZONE).format("DD.MM.YYYY HH:mm")
}

export function formatDateShort(input: string) {
    if (!input) {
        return '';
    }

    return moment.tz(input, DISPLAY_TIMEZONE).format("DD.MM HH:mm")
}
